import { DistributionGuard } from './distribution.guard';

export const guards: any[] = [DistributionGuard];

export * from './distribution.guard';
